import { render, staticRenderFns } from "./SliderWithButtons.vue?vue&type=template&id=0b1f2810&scoped=true&"
import script from "./SliderWithButtons.vue?vue&type=script&lang=ts&"
export * from "./SliderWithButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SliderWithButtons.vue?vue&type=style&index=0&id=0b1f2810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f2810",
  null
  
)

export default component.exports